if (!customElements.get('product-description-toggle')) {
  customElements.define('product-description-toggle', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.product-description-toggle__content');
      this.button = this.querySelector('button');
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.expanded = false;
      const measure = () => {
        const lineHeight = parseFloat(getComputedStyle(this.content).lineHeight) || 24;
        this.style.setProperty('--description-preview-height', `${lineHeight * 3}px`);
        this.long = this.content.scrollHeight > lineHeight * 3 + 2;
        this.render();
      };
      this.button.addEventListener('click', () => {
        this.expanded = !this.expanded;
        this.render();
        if (!this.expanded && this.getBoundingClientRect().top < 0) this.scrollIntoView({ block: 'center' });
        const parameters = { expanded: this.expanded };
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'product_description_toggle', parameters);
        } else {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'product_description_toggle', ...parameters });
        }
      }, { signal });
      this.content.addEventListener('focusin', () => {
        this.expanded = true;
        this.render();
      }, { signal });
      this.observer = new ResizeObserver(measure);
      this.observer.observe(this.content);
      measure();
      document.fonts.ready.then(() => { if (this.isConnected) measure(); });
    }

    render() {
      this.toggleAttribute('data-collapsed', this.long && !this.expanded);
      this.button.hidden = !this.long;
      this.button.setAttribute('aria-expanded', String(!this.long || this.expanded));
      this.button.textContent = this.expanded ? this.dataset.readLess : this.dataset.readMore;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

if (!customElements.get('product-information')) {
  customElements.define('product-information', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.querySelectorAll('details[data-product-panel]').forEach((panel) => {
        panel.addEventListener('toggle', () => {
          if (!panel.open) return;
          const parameters = { panel_name: panel.dataset.productPanel, product_id: this.dataset.productId };
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'product_accordion_open', parameters);
          } else {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'product_accordion_open', ...parameters });
          }
        }, { signal: this.controller.signal });
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
